import clsx from 'clsx'
import { Icon } from '@/components'
import { StatusTone } from './ChargeForecastV2.types'

export const STATUS_TONE_BACKGROUNDS: Record<StatusTone, string> = {
  'optimizing-paused': 'bg-themed-purple-500',
  'optimizing-charging': 'bg-themed-green-900',
  'not-optimizing': 'bg-themed-grey-500',
}

type Props = {
  tone: StatusTone
  title: string
  subtitle: string | null
  // When the car last reported, e.g. "Last Updated: 5 minutes ago"
  lastUpdated: string | null
  infoLabel: string
  // The info icon only renders when there's something to explain
  onInfoClick?: () => void
}

export default function StatusHeader({
  tone,
  title,
  subtitle,
  lastUpdated,
  infoLabel,
  onInfoClick,
}: Props) {
  return (
    <div
      className={clsx(
        'box-border flex items-center w-full gap-2 p-4 rounded-t-[20px]',
        STATUS_TONE_BACKGROUNDS[tone],
      )}
    >
      <div className="flex items-start flex-1 min-w-0 gap-2">
        <span className="flex items-center justify-center w-5 h-5 shrink-0">
          <Icon name="Leaf" color="white" size={16} aria-hidden />
        </span>
        <div className="flex flex-col min-w-0 gap-0.5 text-white">
          <span className="text-sm font-bold leading-5">{title}</span>
          {subtitle && (
            <span className="text-xs font-medium leading-normal">
              {subtitle}
            </span>
          )}
          {lastUpdated && (
            <span className="text-xs font-medium leading-normal">
              {lastUpdated}
            </span>
          )}
        </div>
      </div>
      {onInfoClick && (
        <button
          id="charge-forecast-v2-status-info"
          type="button"
          aria-label={infoLabel}
          onClick={onInfoClick}
          className="flex items-center justify-center w-6 h-6 p-0 -m-1 bg-transparent border-0 cursor-pointer shrink-0"
        >
          <Icon
            name="Info"
            color="white"
            size={16}
            strokeWidth={1.5}
            aria-hidden
          />
        </button>
      )}
    </div>
  )
}
